import Highlighter from 'react-highlight-words'
import { normalizeText } from 'util/string/string-normalizeText'

interface NormalizedHighlighterProps {
  textToHighlight: string
  searchWords: string
  splitWords: boolean
}

export const NormalizedHighlighter = (props: NormalizedHighlighterProps) => (
  <Highlighter
    searchWords={props.searchWords?.split(props.splitWords && /\s/) ?? []}
    textToHighlight={props.textToHighlight}
    sanitize={(val: string) => normalizeText(val).escapeRegExp()}
  />
)

NormalizedHighlighter.defaultProps = {
  splitWords: true,
} as NormalizedHighlighterProps
